// Services
import { HttpService } from "@mgs/ci2019-common/src/services/HttpService";

// Store
import { Store } from "#/store";

// Model
import { Person } from "#/common/interfaces/Person";

export class PersonService {
  private static _instance;

  public static get instance() {
    if (!this._instance) {
      this._instance = new PersonService();
    }
    return this._instance;
  }

  private constructor() {}

  private readonly http: HttpService = HttpService.instance;

  public async getPerson(arr: Array<any>): Promise<Array<Person>> {
    let idStr = arr
      .map((item, index) => {
        return `id[${index}]=${item}`;
      })
      .join("&");

    let queryUrl =
      Store.instance.ui.ansprechpartnerApiUrl + `public/person?${idStr}`;

    const response = await this.http.get<Array<Person>>(queryUrl);

    return response.body!;
  }
}
